module.exports = __webpack_public_path__ + "static/media/2.32531407.jpg";